var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "footer footer-custom" }, [
      _c("div", { staticClass: "container text-center text-white" }, [
        _c("div", { staticClass: "promo" }, [
          _c("div", [
            _c("p", [
              _c("span", { staticStyle: { "margin-right": "5px" } }, [
                _vm._v("Powered by Aristotle Metadata Registry")
              ]),
              _vm._v(" "),
              _c("a", { attrs: { href: "https://aristotlemetadata.com" } }, [
                _c("img", {
                  attrs: { src: require("../assets/aris_logo_small.png") }
                })
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }